const observer = new MutationObserver((mutations, obs) => {
  const target = document.querySelector('.builder-block.builder-block[class*="builder-"].with-upez-loader.css-sokhbh.upez-btn--checkout');
  if (target) {
    const buildBannerHTML = `
      <div class="review-card hide-mobile">
  <div class="review-image">
    <img src="https://cdn.shopify.com/s/files/1/1871/2013/files/Rectangle_28.png?v=1760079295" alt="Reviewer">
  </div>
  <div class="review-content">
    <div class="stars">
      ★★★★★
    </div>
    <p class="review-text">
      The flavors are intense and the heat levels are spot on.
      My favorite has to be the Simple Hot Sauce – perfect balance of sweet and smoky.
    </p>
    <p class="review-name">Amelia</p>
  </div>
</div>

    `;

    target.insertAdjacentHTML('afterend', buildBannerHTML);
    console.log('Banner inserted via MutationObserver');
    obs.disconnect(); // stop observing once done
  }
});

observer.observe(document.body, { childList: true, subtree: true });



document.addEventListener("DOMContentLoaded", () => {
  const observer2 = new MutationObserver((mutations, obs) => {
    const target2 = document.querySelector('.builder-block[class*="builder-"].builder-has-component.css-u752mu .builder-text.css-1qggkls');
    
    if (target2) {
      const buildBannerHTML = `<p class="custom-text">Your Sauces:</p>`;
      target2.insertAdjacentHTML('afterend', buildBannerHTML);
      console.log('Banner inserted via MutationObserver');
      obs.disconnect();
    }
  });

  observer2.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", () => {
  const changeNumbersToPlus = () => {
    const spans = document.querySelectorAll('.builder-block.builder-edc46aeb35954d74ba247b793fd7f043.builder-has-component.css-1ksobn3 .builder-text.css-1qggkls');
    spans.forEach(span => {
      const text = span.textContent.trim();

      // Check: is it a number AND not already '+'
      if (!isNaN(text) && text !== '' && text !== '+') {
        span.textContent = '+';
        console.log(`✅ Changed ${text} → +`);
      }
    });
  };

  // Initial run (in case elements already exist)
  changeNumbersToPlus();

  // Continuous observer (for dynamically added Builder elements)
  const observer = new MutationObserver(() => {
    changeNumbersToPlus();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

function changeAddToCartText() {
  const el = [...document.querySelectorAll('.builder-block.builder-block[class*="builder-"].builder-has-component.css-wa142n .builder-text')]
              .find(e => e.textContent.trim() === 'Add to cart');
  if (el) {
    el.textContent = 'Continue to checkout';
    clearInterval(interval); // stop checking once done
  }
}

// Check every 200ms until the element exists
const interval = setInterval(changeAddToCartText, 200);


// collabse bundle 



